'use strict';

/**
 * Verifica che il parametro in input sia un istanza di jQuery
 * @param sender
 * @returns {boolean}
 */
module.exports = function isJquery(sender) {
    return sender instanceof $;
};
